// extracted by mini-css-extract-plugin
export default {"planCardWapper":"plans_planCardWapper__V6aWI","planCard":"plans_planCard__JR2ri","invoiceLogo":"plans_invoiceLogo__YFQMS"};